import { BaseEntityDTO, IBaseEntityDTO, IReleaseDTO, ReleaseDTO } from './';

export const ReleaseTypeEnum: { [key: string]: { release_name: string; id: string } } = {
  Talent: {
    release_name: 'Talent',
    id: 'a41504bc-6da4-48b4-b674-333447a713ec',
  },
  Music: {
    release_name: 'Music',
    id: '382a7ede-9de5-4c24-8ab9-4adb857bfdcb',
  },
  Location: {
    release_name: 'Location',
    id: '5823d3a5-50f4-446f-ad65-bf23d8da5bae',
  },
};

export interface IReleaseTypeDTO extends IBaseEntityDTO {
  release_name: string;
  releases: IReleaseDTO[];
}
export class ReleaseTypeDTO extends BaseEntityDTO implements IReleaseTypeDTO {
  release_name: string;
  releases: IReleaseDTO[];

  constructor(data?: Partial<ReleaseTypeDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.release_name = data?.release_name ?? '';
    this.releases = data?.releases ? data.releases.map((release) => new ReleaseDTO(release)) : [];
  }
}
